import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.applyPreset.mutation.gql"
import type {
  TenantPrivacyPresetApplyMutation,
  TenantPrivacyPresetApplyMutationVariables,
} from "@/v2-backoffice-client/tenant/privacy/__types__/tenant.privacy.applyPreset.mutation"

type Options = MutationHookOptions<
  TenantPrivacyPresetApplyMutation,
  TenantPrivacyPresetApplyMutationVariables
>

export function useTenantPrivacyPresetApplyMutation(options?: Options) {
  return useMutation<
    TenantPrivacyPresetApplyMutation,
    TenantPrivacyPresetApplyMutationVariables
  >(mutation, options)
}
